import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  UpdateStatusSyncProductsBody,
  CreateInvitationBody,
  InvitationApi,
  CreateSyncProductsBody,
  CreateSyncProductDiariesBody,
  FilterInvitationOptions,
  FindInvitationInfoOptions,
} from 'api';

export const findInvitation = createAsyncThunk(
  'invitation/findInvitation',
  async (options: any, { rejectWithValue }) => {
    try {
      const response = await InvitationApi.find(options);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

// type: 0: 'supplier', 1: 'customer'
export const createInvitation = createAsyncThunk(
  'invitation/createInvitation',
  async (data: CreateInvitationBody, { rejectWithValue }) => {
    try {
      const response = await InvitationApi.create(data);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterInvitation = createAsyncThunk(
  'invitation/filterInvitation',
  async (option: FilterInvitationOptions, { rejectWithValue }) => {
    try {
      const response = await InvitationApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findWaitingInvitation = createAsyncThunk(
  'invitation/findWaitingInvitation',
  async (option: FilterInvitationOptions, { rejectWithValue }) => {
    try {
      const response = await InvitationApi.findWaitingInvitation(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createSyncProducts = createAsyncThunk(
  'invitation/createSyncProducts',
  async (data: CreateSyncProductsBody, { rejectWithValue }) => {
    try {
      const response = await InvitationApi.createSyncProducts(data);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createSyncProductDiaries = createAsyncThunk(
  'invitation/createSyncProductDiaries',
  async (data: CreateSyncProductDiariesBody, { rejectWithValue }) => {
    try {
      const response = await InvitationApi.createSyncProductDiaries(data);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateStatusSyncProducts = createAsyncThunk(
  'invitation/updateStatusSyncProducts',
  async (
    params: { id: string; body: UpdateStatusSyncProductsBody },
    { rejectWithValue }
  ) => {
    const { id, body } = params;
    try {
      const response = await InvitationApi.updateStatusSyncProducts(id, body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateStatusSyncProductDiaries = createAsyncThunk(
  'invitation/updateStatusSyncProductDiariess',
  async (
    params: { id: string; body: UpdateStatusSyncProductsBody },
    { rejectWithValue }
  ) => {
    const { id, body } = params;
    try {
      const response = await InvitationApi.updateStatusSyncProductDiaries(
        id,
        body
      );
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateInvitationStatus = createAsyncThunk(
  'invitation/updateInvitationStatus',
  async (
    { id, status }: { id: string; status: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await InvitationApi.updateStatus(id, status);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteInvitation = createAsyncThunk(
  'invitation/deleteInvitation',
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      const response = await InvitationApi.delete(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const cancelInvitation = createAsyncThunk(
  'invitation/cancelInvitation',
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      const response = await InvitationApi.cancelInvitation(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findInvitationInfo = createAsyncThunk(
  'invitation/findInvitationInfo',
  async (option: FindInvitationInfoOptions, { rejectWithValue }) => {
    try {
      const response = await InvitationApi.findInvitationInfo(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface InvitationState {
  data: any[];
}

const initialState: InvitationState = {
  data: [],
};

const invitationSlice = createSlice({
  name: 'invitation',
  initialState,
  reducers: {},
  //   extraReducers: builder => {},
});

const { reducer: invitationReducer } = invitationSlice;

export default invitationReducer;
